// extracted by mini-css-extract-plugin
export var heading = "stepperCard-module--heading--3f1b8";
export var paper = "stepperCard-module--paper--37e7a";
export var paragraph = "stepperCard-module--paragraph--d5dce";